export default {
    mergeProjects: 'Merge Projects',
    mergeProjectsDescription: 'Merge multiple projects into one. The second project will be appended to the first one, creating a new project that contains data from both. The original projects will remain unchanged.',
    start: 'Start',
    projectsMerged: 'Projects successfully merged',
    mergeFailed: 'Merge failed',
    instanceName: 'Instance Name',
    instanceType: 'Instance Type',
    GoToProject: 'Go to Project',
    projectVersion: 'Project Version',
    versionMismatch: 'The versions of the projects do not match.',
    versionMismatchSolution: 'Please update the projects to the same version before merging. This can be done by updating the projects in vSTAGE.',
    versionInvalidSolution: 'Please upgrade your project to the version {version} or higher to merge it.',
    selectProject: 'Select Project',
    noProjectSelected: 'No project selected',
    noInstances: 'No instances found',
    projectName: 'Project Name',
    newProject: 'New Project',
    Project1: 'Project 1',
    Project2: 'Project 2',
    mainProjectDescription: 'This is the main project. Global settings such as the selected scene will be taken from this project.',
    resultProject: 'Resulting Project',
    accessMissing: 'You do not have permission for one or more projects or content in the projects.',
    instanceErrors: 'You do not have access for some of the items used in this project.',
    noEditPermission: 'You do not have permission to edit this project.',
    projectIdRequired: 'Project ID is required',
    reStart: 'Merge another project',
}